module.exports = __webpack_public_path__ + "img/baipho_logo.94ee24ae.png";